import { Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import { Attributes, DataSources } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import { Types } from "../../constants/index.js";
import ReleaseFirmwareToImagineGroups from "../../views/ReleaseFirmwareToImagineGroups.js";
const {
  tIcon
} = I18N.ns('api-ui-fota-management.Imagine');
export default function ReleaseFirmware({
  deviceType,
  blueprint
}) {
  return {
    id: `blueprint.action.fota.${blueprint.type}.${deviceType.id}.releaseFirmwareToGroups`,
    name: 'Release Firmware',
    layout: {
      sort: `zz.fota.firmwareRelease.${deviceType.id}.release`,
      group: ['fota', deviceType.id],
      groupNames: ['Firmware', Attributes.get('name', Types.deviceType, deviceType)],
      groupIcons: [tIcon('GroupIcons.firmware'), tIcon('GroupIcons.deviceType')]
    },
    matches: [{
      use: ['contextMenu', 'mobileActionBar'],
      objectType: blueprint.type
    }, {
      client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
      use: ['contextMenu'],
      objectType: blueprint.type
    }],
    isPrepared: cxt => {
      const targets = Context.getTargetsOfType(cxt, blueprint.type);
      if (!(targets?.length > 0)) {
        return true;
      }
      const delegate = DataSources.getDelegate({
        type: Types.firmwareRelease,
        ref: '/firmwareRelease'
      });
      return delegate.canCreate() != null;
    },
    prepare: cxt => {
      const delegate = DataSources.getDelegate({
        type: Types.firmwareRelease,
        ref: '/firmwareRelease'
      });
      return GlobalState.dispatch(delegate.requestCanCreate());
    },
    handles: cxt => {
      const targets = Context.getTargetsOfType(cxt, blueprint.type);
      if (!(targets?.length > 0)) {
        return false;
      }
      const delegate = DataSources.getDelegate({
        type: Types.firmwareRelease,
        ref: '/firmwareRelease'
      });
      return delegate.canCreate();
    },
    appearance: ({
      context
    }) => {
      const targets = Context.getTargetsOfType(context, blueprint.type);
      return {
        name: `Release Firmware at ${targets.length} ${targets.length === 1 ? blueprint.name : blueprint.namePlural}`,
        icon: tIcon('ReleaseFirmwareAction.icon')
      };
    },
    perform: ({
      context
    }) => {
      const {
        reloadData,
        clientProps: {
          delegate
        }
      } = context;
      const targets = Context.getTargetsOfType(context, blueprint.type);
      Dialogs.show({
        component: ReleaseFirmwareToImagineGroups,
        props: {
          targets,
          delegate,
          reloadData,
          deviceType,
          blueprint
        }
      });
    }
  };
}